import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const ServiceEvaluationForm = ({selectedFormId,data,selectedClientDetails}) => {

    const { t } = useTranslation();
    const initialFormData = {
    analystKnowledgeable: "",
    analystResponsive: "",
    analystSkilled: "",
    analystSupportive: "",
    analystListener: "",
    analystGuide: "",
    networkOrganized: "",
    networkResponsive: "",
    networkSupportive: "",
    objectivesAchieved: "",
    symptomsReduced: "",
    learnedManagement: "",
    didHomeActivities: "",
    learnedAboutSelf: "",
    learningValuable: "",
    bigEffect: "",
    likelyRecommend: "",
    comments: "",
  }
  
  const [formData, setFormData] = useState(data?data:initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

   const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = () => {
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
  };

  console.log("📤 Sending form payload:", payload);

  fetch(API_URL + "/forms/client/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      // Stop loader in all cases
      setLoading(false);
    });
};



  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "1200px",
        margin: !data ? "20px auto" : "auto",
        padding: "20px",
        border: !data && "1px solid #ccc",
      }}
    >
      <h3
        style={{
          fontSize: "22px",
    fontWeight: "bold",
    color: "#800080",
    textAlign: "center",
    marginBottom: "16px",
        }}
      >
        SERVICE EVALUATION
      </h3>

      <form onSubmit={handleSubmit}>
        {/* Instructions */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
            Please place a number, 1 - 7, following each statement, where:
          </p>
          <p style={{ margin: "3px 0" }}>1 = poor</p>
          <p style={{ margin: "3px 0" }}>2 = needs improvement</p>
          <p style={{ margin: "3px 0" }}>3 = marginally acceptable</p>
          <p style={{ margin: "3px 0" }}>4 = average</p>
          <p style={{ margin: "3px 0" }}>5 = good</p>
          <p style={{ margin: "3px 0" }}>6 = very good</p>
          <p style={{ margin: "3px 0" }}>7 = outstanding</p>
        </div>

        {/* Analyst Section */}
        <div style={{ marginBottom: "30px" }}>
          <p
            style={{
              fontWeight: "bold",
              fontStyle: "italic",
              marginBottom: "10px",
            }}
          >
            My Breathing Analyst was:
          </p>
          {[
            { label: "knowledgeable", name: "analystKnowledgeable" },
            { label: "responsive", name: "analystResponsive" },
            { label: "skilled", name: "analystSkilled" },
            { label: "supportive", name: "analystSupportive" },
            { label: "a good listener", name: "analystListener" },
            { label: "a helpful guide", name: "analystGuide" },
          ].map((item) => (
            <div
              key={item.name}
              style={{ display: "flex", alignItems: "flex-end", margin: "5px 0" }}
            >
              <label>{item.label}:</label>
              <input
                type="text"
                name={item.name}
                value={formData[item.name]}
                onChange={handleChange}
                style={{
                  width: "40px",
                  marginLeft: "5px",
                  borderBottom: "1px solid #000",
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  outline: "none",
                  height: "30px",
                  backgroundColor: "#f1f4ff",
                }}
              />
            </div>
          ))}
        </div>

        {/* Network Section */}
        <div style={{ marginBottom: "30px" }}>
          <p
            style={{
              fontWeight: "bold",
              fontStyle: "italic",
              marginBottom: "10px",
            }}
          >
            The Breathing Science Network was:
          </p>
          {[
            { label: "organized", name: "networkOrganized" },
            { label: "responsive", name: "networkResponsive" },
            { label: "supportive", name: "networkSupportive" },
          ].map((item) => (
            <div
              key={item.name}
              style={{ display: "flex", alignItems: "center", margin: "5px 0" }}
            >
              <label>{item.label}:</label>
              <input
                type="text"
                name={item.name}
                value={formData[item.name]}
                onChange={handleChange}
                style={{
                  width: "40px",
                  marginLeft: "5px",
                  borderBottom: "1px solid #000",
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  outline: "none",
                  height: "30px",
                  backgroundColor: "#f1f4ff",
                }}
              />
            </div>
          ))}
        </div>

        {/* Learning Statements */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
            Please rate the following statements, 1 - 7, where 1 = "no" and 7 = varying degrees of "yes."
          </p>
          {[
            { label: "My learning objectives were achieved.", name: "objectivesAchieved" },
            { label: "My breathing-related symptoms were significantly reduced.", name: "symptomsReduced" },
            { label: "I learned how to manage my breathing related symptoms.", name: "learnedManagement" },
            { label: "I did the home learning activities as discussed (rather than assigned).", name: "didHomeActivities" },
            { label: "I learned a lot about myself and how my habits affect me.", name: "learnedAboutSelf" },
            { label: "Learning about my breathing and how it affected me was a valuable experience.", name: "learningValuable" },
            { label: "My learning experience has had a big effect on my life.", name: "bigEffect" },
            { label: "I am likely to recommend breathing services to a friend, family, or a colleague.", name: "likelyRecommend" },
          ].map((item) => (
            <div
              key={item.name}
              style={{ display: "flex", alignItems: "center", margin: "5px 0" }}
            >
              <label>{item.label}</label>
              <input
                type="text"
                name={item.name}
                value={formData[item.name]}
                onChange={handleChange}
                style={{
                  width: "40px",
                  marginLeft: "5px",
                  borderBottom: "1px solid #000",
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  outline: "none",
                  height: "30px",
                  backgroundColor: "#f1f4ff",
                }}
              />
            </div>
          ))}
        </div>

        {/* Comments */}
        <div style={{ marginBottom: "30px" }}>
          <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
            We would appreciate any comments that you may wish to make. Thank you!
          </p>
          <textarea
            name="comments"
            value={formData.comments}
            onChange={handleChange}
            style={{
              width: "100%",
              height: "120px",
              border: "1px solid #000",
              padding: "8px",
              boxSizing: "border-box",
            }}
          />
        </div>

      {!data &&    <div className="client-submit-btn">
        <button type="button" onClick={handleSubmit}>
        {loading?t("Submitting..."):t("Submit")}
        </button>
      </div>}
      </form>
       <Modal
                                      isOpen={successModal}
                                      toggle={successToggleModal}
                                      className="connect-box"
                                      centered={true}
                                    >
                                      <ModalHeader toggle={successToggleModal}>
                                        <span className="ml-1 roititle font-weight-bold">
                                          Successfull
                                        </span>
                                      </ModalHeader>
                                      <ModalBody>
                                        <div className="modal-p">
                                          <p>Client form has been submitted successfully.</p>
                                        </div>
                                      </ModalBody>
                                    </Modal>
    </div>
  );
};

export default ServiceEvaluationForm;
